module.exports = __webpack_public_path__ + "static/images/amenity.0d165d6e681cd422d5fba1d24e9daeb0.svg";